import { render, staticRenderFns } from "./realNameAuthenticationListInfo.vue?vue&type=template&id=4d8ae8ef"
import script from "./realNameAuthenticationListInfo.vue?vue&type=script&lang=js"
export * from "./realNameAuthenticationListInfo.vue?vue&type=script&lang=js"
import style0 from "./realNameAuthenticationListInfo.vue?vue&type=style&index=0&id=4d8ae8ef&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports